import Game from './scenes/Game';
import IntroScreen from './scenes/IntroScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  puzzleData: {
    puzzles: [
      { width: 3, height: 3, answer: 10, paths: [[0,3,6],[3,4,5]], numbers: [1,2,3,4,5] },
      { width: 5, height: 5, answer: 9, paths: [[2,6,10],[10,16,22],[2,12,22]], numbers: [1,2,3,4,5,6] },
      { width: 3, height: 3, answer: 8, paths: [[3,4,5],[1,4,7]], numbers: [1,2,3,4,5] },
      { width: 5, height: 5, answer: 10, paths: [[2,6,10],[10,16,22],[2,12,22]], numbers: [1,2,3,4,5,6] },
      { width: 3, height: 3, answer: 9, paths: [[0,6],[0,4,8],[2,4,6]], numbers: [1,2,3,4,5] },
      { width: 5, height: 5, answer: 12, paths: [[2,6,10],[10,16,22],[2,12,22]], numbers: [1,2,3,4,5,6] },
      { width: 3, height: 3, answer: 9, paths: [[0,4,8],[2,4,6],[2,5,8]], numbers: [1,2,3,4,5,6] },
      { width: 3, height: 3, answer: 12, paths: [[0,1,2],[0,4,8],[2,4,6],[6,7,8],[1,4,7]], numbers: [1,2,3,4,5,6,7] },
      { width: 5, height: 5, answer: 11, paths: [[2,6,10],[10,16,22],[2,12,22]], numbers: [1,2,3,4,5,6] },
      { width: 3, height: 3, answer: 14, paths: [[3,6],[3,4,5],[6,7,8],[2,5,8]], numbers: [2,3,4,5,6,7,8] },
      { width: 4, height: 3, answer: 15, paths: [[0,3,6,9],[6,7,8],[5,8,11]], numbers: [1,2,3,4,5,6,7,8] },
      { width: 3, height: 3, answer: 15, paths: [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]], numbers: [1,2,3,4,5,6,7,8,9] },
      { width: 4, height: 3, answer: 14, paths: [[0,3,6],[1, 4, 7], [0,1], [3,7,11]], numbers: [2,3,4,5,6,7,8] }
    ]
  },
  LEVELS_COMPLETED: [false, false, false, false, false, false, false, false, false, false, false, false, false],
  INSTRUCTIONS_SHOWN: false
};